import React, { useContext, useEffect, useState } from 'react';
import { Table } from 'reactstrap';
import ReactPaginate from 'react-paginate';
import { format } from 'date-fns';
import { ProductContext } from '../../../../store';
import ReportHeader from '../../../../components/Search/ReportHeader';
import ReportSortArrows from '../../../../components/Search/ReportSortArrows';
import DetailSkeleton from '../../../../components/Skeleton/DetailSkeleton';
import TableSkeleton from '../../../../components/Skeleton/TableSkeleton';
import { PostData } from '../../../../services/FetchData';
import { buildReportRequestPayload, getActiveWebsiteId } from '../../../../utils/reportUtils';
import { searchReportsAnalyticsUrl } from '../../../../constants/searchReportsAnalyticsApi';
import { toast } from 'react-toastify';

const HighIntentLowConversionQueries = () => {
    const [pageLoader, setPageLoader] = useState(true),
        [tableLoader, setTableLoader] = useState(true),
        [data, setData] = useState([]),
        [totalPageCount, setTotalPageCount] = useState(0),
        [limit, setLimit] = useState(25),
        [page, setPage] = useState(0),
        [sortField, setSortField] = useState(null),
        [sortOrder, setSortOrder] = useState("desc"),
        { dateRange, setDateRange, currentWebsiteId } = useContext(ProductContext);

    useEffect(() => {
        if (getActiveWebsiteId(currentWebsiteId)) {
            getReports();
        }
    }, [dateRange, limit, page, currentWebsiteId, sortField, sortOrder]);

    // Map frontend field names to API field names
    const mapSortFieldToApi = (field) => {
        const fieldMap = {
            "query": "searchQuery",
            "volume": "searchVolume"
        };
        return fieldMap[field] || field;
    };

    const handleSort = (field, e) => {
        e?.stopPropagation?.();
        if (sortField === field) {
            setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        } else {
            setSortField(field);
            setSortOrder("desc");
        }
        setPage(0);
    };
    const setSort = (field, order, e) => {
      e?.stopPropagation?.();
      setPage(0);
      setSortField(field);
      setSortOrder(order);
    };


    const getReports = () => {
        setTableLoader(true);
                const websiteId = getActiveWebsiteId(currentWebsiteId);
        if (!websiteId) {
            setTableLoader(false);
            setPageLoader(false);
            return;
        }
        const payload = {
            websiteId,
                startDate: format(dateRange.startDate, "yyyy-MM-dd"),
                endDate: format(dateRange.endDate, "yyyy-MM-dd"),
                page: page + 1,
                limit,
                sortField: sortField ? mapSortFieldToApi(sortField) : "",
                sortOrder: sortOrder || "desc",
            };
        
        PostData("ms1", searchReportsAnalyticsUrl("searchHighIntent"), payload).then(response => {
            if (response !== "Invalid" && response !== "undefined") {
                if (response.status === "success") {
                    const transformedData = response.data.data.map(item => {
                        return {
                            query: item.searchQuery || "",
                            volume: item.searchVolume || 0,
                            ctr: typeof item.ctr === 'number' ? item.ctr.toFixed(2) + "%" : "0.00%",
                            addToCartRate: typeof item.addToCartRate === 'number' ? item.addToCartRate.toFixed(2) + "%" : "0.00%",
                            conversionRate: typeof item.conversionRate === 'number' ? item.conversionRate.toFixed(2) + "%" : "0.00%"
                        };
                    });
                    
                    setData(transformedData);
                    
                    let totalRecord = response.data.total,
                        totalPage = Math.ceil(totalRecord / limit);
                    setTotalPageCount(totalPage);
                } else {
                    toast.error(response.message);
                }
            }
            setTableLoader(false);
            setPageLoader(false);
        }).catch(err => {
            console.error("Error fetching high intent low conversion queries:", err);
            setTableLoader(false);
            setPageLoader(false);
        });
    };

    return (
        <div>
            {pageLoader ?
                <DetailSkeleton />
            :
                <React.Fragment>
                    <ReportHeader range={dateRange} onDateChange={(range) => setDateRange(range)} />
                    <div className="tab-content mt-3">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h4 className="mb-0">High-Intent Queries With Low Conversion</h4>
                            <div className="d-flex align-items-center">
                                <label htmlFor="limit" className="me-2">
                                    Items Per Page:
                                </label>
                                <select id="limit" className="form-select" value={limit} onChange={(e) => setLimit(Number(e.target.value))} style={{ width: "100px", fontSize: "12px" }}>
                                    <option value={25}>25</option>
                                    <option value={30}>30</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                </select>
                            </div>
                        </div>
                        <div>
                            {tableLoader ?
                                <TableSkeleton />
                            :
                                <Table className={`table ${data.length > 0 ? "table-striped" : ""} mt-3 custom-bordered-table`}>
                                    <thead>
                                        <tr>
                                            <th className="sortable-header" style={{ cursor: "pointer" }} onClick={(e) => handleSort("query", e)}>
                                                <div className="sortable-header-inner">
                                                    Search Query
                                                    <ReportSortArrows field="query" activeSortField={sortField} sortOrder={sortOrder} onSort={setSort} />
                                                </div>
                                            </th>
                                            <th className="sortable-header" style={{ cursor: "pointer" }} onClick={(e) => handleSort("volume", e)}>
                                                <div className="sortable-header-inner">
                                                    Search Volume
                                                    <ReportSortArrows field="volume" activeSortField={sortField} sortOrder={sortOrder} onSort={setSort} />
                                                </div>
                                            </th>
                                            <th className="sortable-header" style={{ cursor: "pointer" }} onClick={(e) => handleSort("ctr", e)}>
                                                <div className="sortable-header-inner">
                                                    CTR %
                                                    <ReportSortArrows field="ctr" activeSortField={sortField} sortOrder={sortOrder} onSort={setSort} />
                                                </div>
                                            </th>
                                            <th className="sortable-header" style={{ cursor: "pointer" }} onClick={(e) => handleSort("addToCartRate", e)}>
                                                <div className="sortable-header-inner">
                                                    Add-to-Cart Rate %
                                                    <ReportSortArrows field="addToCartRate" activeSortField={sortField} sortOrder={sortOrder} onSort={setSort} />
                                                </div>
                                            </th>
                                            <th className="sortable-header" style={{ cursor: "pointer" }} onClick={(e) => handleSort("conversionRate", e)}>
                                                <div className="sortable-header-inner">
                                                    Conversion Rate %
                                                    <ReportSortArrows field="conversionRate" activeSortField={sortField} sortOrder={sortOrder} onSort={setSort} />
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.length === 0 ? (
                                            <tr>
                                                <td colSpan={5}>
                                                    <div className="emptyPlaceholder">
                                                        <div>
                                                            <div>
                                                                <img src={require("./../../../../assets/images/paper-plane-grey.png")} className='img-fluid' alt="No data found" />
                                                            </div>
                                                            <div className="rsInfoMsg disabled">
                                                                <div className="flex-1">No records found.</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ) : (
                                            data.map((row, index) => (
                                                <tr key={index}>
                                                    <td>{row.query}</td>
                                                    <td>{row.volume?.toLocaleString() || 0}</td>
                                                    <td>{row.ctr}</td>
                                                    <td>{row.addToCartRate}</td>
                                                    <td>{row.conversionRate}</td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </Table>
                            }
                            {totalPageCount > 1 &&
                                <div className='d-flex justify-content-center mt-5'>
                                    <ReactPaginate
                                        nextLabel=">"
                                        onPageChange={(event) => setPage(event.selected)}
                                        page={page}
                                        pageRangeDisplayed={3}
                                        marginPagesDisplayed={2}
                                        pageCount={totalPageCount}
                                        previousLabel="<"
                                        pageClassName="page-item"
                                        pageLinkClassName="page-link"
                                        previousClassName="page-item"
                                        previousLinkClassName="page-link"
                                        nextClassName="page-item"
                                        nextLinkClassName="page-link"
                                        breakLabel="..."
                                        breakClassName="page-item"
                                        breakLinkClassName="page-link"
                                        containerClassName="pagination"
                                        activeClassName="active"
                                        renderOnZeroPageCount={null}
                                    />
                                </div>
                            }
                        </div>
                    </div>
                </React.Fragment>
            }
        </div>
    );
};

export default HighIntentLowConversionQueries;
